<template>
    <div>
        <b-form-group
            label="SMTP"
        >
            <b-button variant="primary" @click="settingsModal.show = true">Edit</b-button>
        </b-form-group>

        <InputField type="text" name="to" :label="this.$t('capital.to')" v-model="content.to" @error="fieldError"
            :rules="{required: true, length: {min: 2, max: 128}}"
            :helpTip="{id: 'event.operation.mustache', text: $t('usePlaceholders')}"
        />

        <InputField type="text" name="cc" :label="this.$t('cc')" v-model="content.cc" @error="fieldError"
            :rules="{required: false, length: {min: 2, max: 128}}"
            :helpTip="{id: 'event.operation.mustache', text: $t('usePlaceholders')}"
        />

        <InputField type="text" name="bcc" :label="this.$t('bcc')" v-model="content.bcc" @error="fieldError"
            :rules="{required: false, length: {min: 2, max: 128}}"
            :helpTip="{id: 'event.operation.mustache', text: $t('usePlaceholders')}"
        />

        <InputField type="text" name="subject" :label="this.$t('subject')" v-model="content.subject" @error="fieldError"
            :rules="{required: true, length: {min: 2, max: 128}}"
            :helpTip="{id: 'event.operation.mustache', text: $t('usePlaceholders')}"
        />

        <CodeEditor
            v-model="content.body"
            :label-cols="2"
            :horizontal="true"
            :label="$t('body')"
        />

        <b-form-group
            :label="this.$t('attachments')"
        >
            <b-row v-for="(attachment, i) in files" :key="i">
                <b-col cols="12" sm="4"> <b-select v-model="files[i].type" :options="['html2pdf']" /> </b-col>
                <b-col cols="12" sm="3">
                    <b-input type="text" v-model="files[i].name" placeholder="Name" />
                </b-col>
                <b-col cols="12" sm="4">
                    <CodeEditor
                        v-model="files[i].value"
                    />
                </b-col>
                <b-col cols="12" sm="1" @click="removeFile(i)"><i class="fa fa-trash"></i></b-col>
            </b-row>
            <b-button variant="success" @click="addAttachment" class="mt-2"> {{ $t('add') }} </b-button>
        </b-form-group>

        <main-dialog title="SMTP" v-model="settingsModal.show" hide-footer>
            <InputField type="text" name="username" :label="this.$t('username')" v-model="content.smtp.username" @error="fieldError"
                :rules="{required: true, length: {min: 2, max: 128}}"
                :helpTip="{id: 'event.operation.mustache', text: $t('usePlaceholders')}"
            />

            <InputField type="password" name="password" :label="this.$t('password')" v-model="content.smtp.password" @error="fieldError"
                :rules="{required: true, length: {min: 2, max: 128}}"
                :helpTip="{id: 'event.operation.mustache', text: $t('usePlaceholders')}"
            />

            <InputField type="text" name="port" :label="this.$t('port')" v-model="content.smtp.port" @error="fieldError"
                :rules="{required: true, length: {min: 2, max: 128}}"
                :helpTip="{id: 'event.operation.mustache', text: $t('usePlaceholders')}"
            />

            <InputField type="text" name="host" :label="this.$t('host')" v-model="content.smtp.host" @error="fieldError"
                :rules="{required: true, length: {min: 2, max: 128}}"
                :helpTip="{id: 'event.operation.mustache', text: $t('usePlaceholders')}"
            />

            <InputField type="text" name="email_from" :label="this.$t('emailFrom')" v-model="content.smtp.email_from" @error="fieldError"
                :rules="{required: true, length: {min: 2, max: 128}}"
                :helpTip="{id: 'event.operation.mustache', text: $t('usePlaceholders')}"
            />

            <SelectField type="text" name="auth_type" :label="this.$t('authType')" v-model="content.smtp.auth_type" @error="fieldError"
                :rules="{required: true, length: {min: 2, max: 128}}"
                :items="['plain', 'crammd5']"
            />
        </main-dialog>
    </div>
</template>

<script>
import InputField from '@/components/form/Input'
import SelectField from '@/components/form/Select'
import CodeEditor from '@/components/form/Editor/HtmlCode'

export default {
    components: {
        InputField,
        SelectField,
        CodeEditor
    },
    props: {
       value: {
         type: Object
       }
    },
    computed: {
        content: {
            get() {
                return this.value || {};
            },

            set(val) {
                this.$emit('input', val);
            }
        },
    },
    methods: {
        fieldError(error) {
            let found = this.errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.errors.push(error)
            } else {
                this.errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        checkForErrors() {
            return this.errors.find((i, e) => {
                return i.error
            })
        },

        save() {
            this.modal.show = false
            this.content.attachments = this.files
        },

        addAttachment() {
            this.files.push({
                name: '',
                type: 'html2pdf', // || 'media'
                value: ''
            })
        },

        removeFile(i) {
            this.files.splice(i, 1)
        }
    },
    data: function() {
        return {
            errors: [],
            modal: {
                show: false
            },
            files: [],
            settingsModal: {
                show: false,
            }
        }
    },

    mounted() {
        this.files = this.content.attachments || []
        // backwards compatibility
        if (!this.content.smtp) {
            this.content.smtp = {}
        }
    }
}
</script>
